import { request } from '@/utils/request'

export class ProfilesConfiguration {
    constructor() {
        this.__loading = 0
        this.__investmentStrategies = []
    }

    get loading() {
        return this.__loading > 0
    }

    get investmentStrategies() {
        if (this.__investmentStrategies.length === 0) {
            this.__loadConfiguration()
        }

        return this.__investmentStrategies
    }

    async __loadConfiguration() {
        if (this.__loading > 0) {
            return
        }

        this.__loading += 1
        try {
            this.__apply(await request.get('/api/account/profile/configuration'))
        } catch {
            // yuck
        }
        this.__loading -= 1
    }

    __apply(content) {
        if (content.investmentStrategies) {
            this.__investmentStrategies = content.investmentStrategies.sort((lhs, rhs) => lhs.localeCompare(rhs))
        }
    }
}
